import { MenuItem, Select } from "@mui/material";
import { ISettingOption } from "../../../Settings/settingsTypes";


interface SettingDropDownProps {
    options: ISettingOption<any>[];
    value: any;
    onChange: (newValue: any) => void;
}

const SettingDropDown = (props: SettingDropDownProps): JSX.Element => {

    return (
        <Select value={props.value} onChange={v => props.onChange(v.target.value)}>
        {props.options.map((option, _idx) => 
            <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>
        )}
        </Select>
    );
}

export default SettingDropDown;